import { orderHistorySearchTagsStyles } from "@insite/content-library/Widgets/OrderHistory/OrderHistorySearchTags";
import { ButtonWrapper } from "@insite/mobius/Button";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

orderHistorySearchTagsStyles.appliedFilterTag = {
    css: css`
        background-color: #f3efeb;
        border-radius: 4px;
        color: ${getColor("primary")};
        ${TypographyStyle} {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }
        > ${ButtonWrapper} {
            background-color: transparent;
        }
    `,
};
